import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';

import { ToastService } from '../../../modules/shared/services/toast-message.service';
import { IntegrationsService } from '../../../services/integrations/integrations.service';
import * as actions from './integrations.actions';
import { IIntegration } from './models/integrations';

@Injectable()
export class IntegrationsEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly service: IntegrationsService,
    private readonly toastService: ToastService,
  ) {}

  getIntegrations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.getIntegrations),
      exhaustMap(() =>
        this.service.getIntegrations().pipe(
          map((integrations: IIntegration[]) => {
            return actions.getIntegrationsSuccess({ integrations });
          }),
          catchError((error: any) => of(actions.getIntegrationsFailure(error))),
        ),
      ),
    ),
  );

  deleteIntegration$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.deleteIntegration),
      exhaustMap((action) =>
        this.service.deleteIntegration(action.id).pipe(
          map(() => {
            this.toastService.success('Integration successfully removed.');
            return actions.deleteIntegrationSuccess();
          }),
          catchError((error: any) => of(actions.deleteIntegration(error))),
        ),
      ),
    ),
  );

  deleteIntegrationSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.deleteIntegrationSuccess),
      map(() => actions.getIntegrations()),
    ),
  );
}
